/* eslint-disable no-underscore-dangle */
import { createStore, applyMiddleware, compose } from 'redux';
import thunk from 'redux-thunk';
import promiseMiddleware from 'redux-promise-middleware';

import rootReducer, { IRootState } from '../reducers';
import errorMiddleware from '../config/error-middleware';
import loggerMiddleware from '../config/logger-middleware';

// declare const window: any;
declare global {
    interface Window {
        __REDUX_DEVTOOLS_EXTENSION_COMPOSE__?: typeof compose;
    }
}

const defaultMiddlewares = [
    thunk,
    errorMiddleware,
    // notificationMiddleware,
    promiseMiddleware,
    loggerMiddleware,
];

const composeEnhancers =
    process.env.NODE_ENV === 'development' && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
        ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
        : compose;

const initialize = (initialState?: IRootState, middlewares = []) =>
    createStore(rootReducer, initialState, composeEnhancers(applyMiddleware(...defaultMiddlewares, ...middlewares)));

export default initialize;
